/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "ashutoshhathidara",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "ashutoshhathidara",
    type: "website",
    url: "http://ashutoshhathidara.asdfscom/",
  },
};

//Home Page
const greeting = {
  title: "Amro Alasri",
  logo_name: "AmroAlasri",
  subTitle: `A forward-thinking and compassionate technology professional with a deep passion for using technology to make a positive impact on the world. With expertise in software engineering, Go Lang  evelopment, and back-end systems, this individual is dedicated to creating reliable, scalable, and efficient solutions that address the world's most pressing challenges and drive progress towards a better future. Committed to using their skills and knowledge to build products that improve people's lives and drive positive change`,
  resumeLink:
    "https://drive.google.com/file/d/1fFBoz-CeHo9nMVRzoT8ZCV-kosg_5gU-/view?usp=share_link",
  portfolio_repository: "https://github.com/amro-alasir",
  githubProfile: "https://github.com/amro-alasri",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Amro-Alasri",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/amro-alasri/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "amr.alasri.994@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Back-End Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Creating application backend in Node.js (Express and Nest), Go Lang (Gin and Fiber) & Python (Django) frameworks",
        "⚡ design, implement, and maintain scalable and efficient back-end systems",
        "⚡ Familiarity with React.js, TypeScript, and Redux for building interactive and dynamic user interfaces and managing application state",
      ],
      softwareSkills: [
        {
          skillName: "GoLang",
          fontAwesomeClassname: "skill-icons:golang",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "python",
          fontAwesomeClassname: "logos:python",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "nestjs",
          fontAwesomeClassname: "skill-icons:nestjs-light",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "logos:c-plusplus",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },

        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },

        {
          skillName: "HTML5",
          fontAwesomeClassname: "skill-icons:html",
          style: {
            color: "#663399",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        // {
        //   skillName: "Azure",
        //   fontAwesomeClassname: "simple-icons:microsoftazure",
        //   style: {
        //     color: "#0089D6",
        //   },
        // },
        // {
        //   skillName: "Firebase",
        //   fontAwesomeClassname: "simple-icons:firebase",
        //   style: {
        //     color: "#FFCA28",
        //   },
        // },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    // {
    //   title: "Golang Develper",
    //   fileName: "GolangDeveloperImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/amro_alasri/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/amro_alasri",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/amro50",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/amro_alasri",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@amro_alasri",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/amroalasri/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sana'a University",
      subtitle: "B.Tech. in information technology",
      logo_path: "IT.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, etc.",
        "⚡ Apart from this, I have done courses on Back-End Development, Cloud Computing",
        "⚡ I have relied on my education through self-directed research, hands-on application, and unwavering diligence, allowing me to develop a wealth of knowledge and valuable skills such as critical thinking and problem solving. I am proud of the achievements I have made through my self-education, which showcases my dedication and drive towards continuous learning and growth",
      ],
      website_link: "",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Programming with Google Go Specialization",
      subtitle: "- University of California, Irvine",
      logo_path: "uci.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/5DYKXZCQD6PG",
      alt_name: "Stanford University",
      color_code: "#275391",
    },
    {
      title: "JavaScript Security Specialization",
      subtitle: "- Coursera",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/AU87TFPYCMRR",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Python for Everybody Specialization",
      subtitle: "- University of Michigan",
      logo_path: "UM.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/GR695N54R9Y9",
      alt_name: "University of Michigan",
      color_code: "#00274b",
    },
    {
      title: "Database Design and Basic SQL in PostgreSQL",
      subtitle: "- University of Michigan",
      logo_path: "UM.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/8XWFNUY8STAU",
      alt_name: "University of Michigan",
      color_code: "#00274b",
    },

    {
      title:
        "Capstone: Retrieving, Processing, and Visualizing Data with Python",
      subtitle: "- University of Michigan",
      logo_path: "UM.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/KDRG2RUA75AC",
      alt_name: "University of Michigan",
      color_code: "#00274b",
    },
    {
      title: "Building Database Applications in PHP",
      subtitle: "- University of Michigan",
      logo_path: "UM.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/LYJBDGNDE2NS",
      alt_name: "University of Michigan",
      color_code: "#00274b",
    },
    {
      title: "Building Web Applications in PHP",
      subtitle: "- University of Michigan",
      logo_path: "UM.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/7VPY8NJGSAX6",
      alt_name: "University of Michigan",
      color_code: "#00274b",
    },
    {
      title: "Introduction to Structured Query Language (SQL)",
      subtitle: "- University of Michigan",
      logo_path: "UM.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/M692NZTAU26H",
      alt_name: "University of Michigan",
      color_code: "#00274b",
    },

    {
      title: "Building RESTful APIs Using Node.js and Express",
      subtitle: "- Back-End",
      logo_path: "niit.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/DXH6VY7MEHV2",
      alt_name: "NIIT",
      color_code: "#133b4d",
    },
    {
      title: "Server side JavaScript with Node.js",
      subtitle: "- Back-End",
      logo_path: "niit.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/X38MY89JQPR7",
      alt_name: "NIIT",
      color_code: "#133b4d",
    },
    {
      title: "Introduction to Git and GitHub",
      subtitle: "- GOOGLE ",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/6EN6UHQQXXQS",
      alt_name: "GOOGLE",
      color_code: "#FFFFFF",
    },
    {
      title: "Linux Fundamentals",
      subtitle: "- Coursera",
      logo_path: "LQ.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/XV5WF97KV2SZ",
      alt_name: "LearnQuest",
      color_code: "#FFFFFF",
    },

    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Introduction to Cloud Computing",
      subtitle: "- IBM Cloud",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/7JVBVNG3W7CU",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Python for Data Science, AI & Development",
      subtitle: "- IBM Cloud",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/UMTA483PFJFQ",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Introduction to Agile Development and Scrum",
      subtitle: "- IBM Cloud",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/2SEAD6TAQHQ7",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Hands-on Introduction to Linux Commands and Shell Scripting",
      subtitle: "- IBM Cloud",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/UMDF7NPZMFYV",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Introduction to DevOps",
      subtitle: "- IBM Cloud",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/RZDRAXZN98DS",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Getting Started with Git and GitHub",
      subtitle: "- IBM Cloud",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/3QY6TYZYSF4G",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "AWS Cloud Technical Essentials",
      subtitle: "- AWS Training",
      logo_path: "awsBlack.jpeg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/3WJRM69593RE",
      alt_name: "AWS",
      color_code: "#262e3b",
    },
    {
      title: "AWS Fundamentals: Migrating to the Cloud",
      subtitle: "- AWS Training",
      logo_path: "awsBlack.jpeg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/BLH4NT76RCXZ",
      alt_name: "AWS",
      color_code: "#262e3b",
    },
    {
      title: "AWS Fundamentals: Addressing Security Risk",
      subtitle: "- AWS Training",
      logo_path: "awsBlack.jpeg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/K2QCBG226GSY",
      alt_name: "AWS",
      color_code: "#262e3b",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked as a freelancer for many years. Creating products in various fields for a diverse local and remote clients.I was responsible of controlling the steering wheel of the whole process. From engaging and communicating with clients, planning, architeting, researching solutions and solving problems I face and also responsible of the whole software development process.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Back-End Developer",
          company: "Freelance",
          company_url: "",
          logo_path: "Freelance.webp",
          duration: "Mar 2020 - PRESENT",
          location: "Remote",
          description:
            "Throughout my career, I have worked on a variety of back-end programming projects, including a restaurant project, a school project, and an attendance and absence system. My experience has honed my ability to tackle complex problems and deliver innovative, efficient, and scalable solutions that exceed client expectations.",
          color: "#0879bf",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    //   {
    //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
    //     name: "Artificial Intelligence Paper",
    //     createdAt: "2020-03-06T16:26:54Z",
    //     description: "Paper Written on Artificial Intelligence published in xyz ",
    //     url:
    //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //   },
    //   {
    //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //     name: "Artificial Intelligence Paper",
    //     createdAt: "2020-03-06T16:26:54Z",
    //     description: "Paper Written on Artificial Intelligence published in xyz ",
    //     url:
    //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //   },
    //   {
    //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //     name: "Artificial Intelligence Paper",
    //     createdAt: "2020-03-06T16:26:54Z",
    //     description: "Paper Written on Artificial Intelligence published in xyz ",
    //     url:
    //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //   },
    //   {
    //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
    //     name: "Artificial Intelligence Paper",
    //     createdAt: "2020-03-06T16:26:54Z",
    //     description: "Paper Written on Artificial Intelligence published in xyz ",
    //     url:
    //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //   },
    //   {
    //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
    //     name: "Artificial Intelligence Paper",
    //     createdAt: "2020-03-06T16:26:54Z",
    //     description: "Paper Written on Artificial Intelligence published in xyz ",
    //     url:
    //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //   },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contactMail.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
